import TFGRequest from './TFGRequest';

export default TFGRequest;
